export default __webpack_public_path__ + "static/media/SaveIcon.2a420c26.svg";